import { View } from 'backbone.marionette';
// import Syphon from 'backbone.syphon';

import CommandInventoryGridView from '../CommandInventoryGridView';

import tmplCommandInventoryView from './CommandInventoryView.hbs';

const CommandInventoryView = View.extend({
  template: tmplCommandInventoryView,

  className: 'command-inventory-view',

  ui: {
    commandInventoryGrid: '.command-inventory-grid'
  },

  regions: {
    commandInventoryGrid: '@ui.commandInventoryGrid'
  },

  onRender() {
    this.showChildView(
      'commandInventoryGrid',
      new CommandInventoryGridView({
        model: this.model
      })
    );
  }
});

export default CommandInventoryView;
